import React from 'react';
import FotoPerfil from '../../assets/avatar.png';
import BinaryImage from '../BinaryImage';
import {
  BINARY_RESOURCES,
  resolveInternalImageRecord,
  resolveThumbnailField,
} from '../../utils/binaryFile';

// Foto principal do interno. Recebe o `internal` (resolve a foto em `images`/`image`) ou direto o
// registro de internalimage em `image`. Sem foto mostra `children` (ex.: iniciais) ou o avatar padrão.
const InternalPhoto = ({ internal, image, preferThumbnail = false, fallbackSrc = FotoPerfil, children, ...imgProps }) => {
  const imageRecord = image || resolveInternalImageRecord(internal);
  const field = preferThumbnail ? resolveThumbnailField(imageRecord) : 'picture';

  return (
    <BinaryImage
      resource={BINARY_RESOURCES.internalImage}
      id={imageRecord?.id}
      field={field}
      fallbackSrc={children ? undefined : fallbackSrc}
      {...imgProps}
    >
      {children}
    </BinaryImage>
  );
};

export default InternalPhoto;
